import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Carousel = makeShortcode("Carousel");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Carousel slots="bgimage, image, heading, text, buttons" repeat="2" theme="lightest" enableNavigation slideTheme='dark' className="carousel-padding-top-zero aws-carousel" varient="fullWidth" navigationNext="white-swiper-button" navigationPre="white-swiper-button" isCenter mdxType="Carousel" />
    <p>{`carousel-micosoft`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.25%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/aa48fd17187d58f14a96f96b3f2cfcaf/5530d/dog-gen-carosul.webp 320w", "/document-services/static/aa48fd17187d58f14a96f96b3f2cfcaf/0c8fb/dog-gen-carosul.webp 640w", "/document-services/static/aa48fd17187d58f14a96f96b3f2cfcaf/94b1e/dog-gen-carosul.webp 1280w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/aa48fd17187d58f14a96f96b3f2cfcaf/dd4a7/dog-gen-carosul.png 320w", "/document-services/static/aa48fd17187d58f14a96f96b3f2cfcaf/0f09e/dog-gen-carosul.png 640w", "/document-services/static/aa48fd17187d58f14a96f96b3f2cfcaf/bbbf7/dog-gen-carosul.png 1280w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/aa48fd17187d58f14a96f96b3f2cfcaf/bbbf7/dog-gen-carosul.png",
            "alt": "Adobe X Microsoft logos",
            "title": "Adobe X Microsoft logos",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "available-on-microsoft-power-automate"
    }}>{`Available on Microsoft Power Automate`}</h2>
    <h3 {...{
      "id": "automate-document-generation-processes-across-crms-forms-and-apps-using-our-pdf-services-connector"
    }}>{`Automate document generation processes across CRMs, forms, and apps using our PDF Services Connector`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.adobe.com/go/powerautomate_help"
        }}>{`Learn more`}</a></li>
    </ul>
    <p>{`carousel-ui-path`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.25%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/d10439078f2515c8f174d8e606858a3e/5530d/Uipath_logo.webp 320w", "/document-services/static/d10439078f2515c8f174d8e606858a3e/0c8fb/Uipath_logo.webp 640w", "/document-services/static/d10439078f2515c8f174d8e606858a3e/94b1e/Uipath_logo.webp 1280w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/d10439078f2515c8f174d8e606858a3e/dd4a7/Uipath_logo.png 320w", "/document-services/static/d10439078f2515c8f174d8e606858a3e/0f09e/Uipath_logo.png 640w", "/document-services/static/d10439078f2515c8f174d8e606858a3e/bbbf7/Uipath_logo.png 1280w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/d10439078f2515c8f174d8e606858a3e/bbbf7/Uipath_logo.png",
            "alt": "Adobe X UiPath logos",
            "title": "Adobe X UiPath logos",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "uipath-integration"
    }}>{`UiPath Integration`}</h2>
    <h3 {...{
      "id": "automate-end-to-end-digital-document-processes-and-workflows-easily-with-uipath-adobe-acrobat-services--and-adobe-acrobat-sign"
    }}>{`Automate end-to-end digital document processes and workflows easily with UiPath, Adobe Acrobat Services,  and Adobe Acrobat Sign.`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://marketplace.uipath.com/listings/adobe-pdf-services"
        }}>{`Learn more`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      